export function getToken(){
    let urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("token") || localStorage.getItem("authToken");
}